import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import api, { formatApiErrorDetail } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) { toast.error("Mínimo 8 caracteres."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success(t("reset_done"));
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F4F8FC]">
      <div className="w-full max-w-sm df-rise">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <h2 className="font-head text-2xl font-bold text-[#0D253F]">{t("reset_title")}</h2>
        {!token ? (
          <p className="text-[#C5221F] mt-4">Token em falta.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div><Label>{t("password")}</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" /></div>
            <Button type="submit" disabled={loading} className="w-full h-12 bg-[#1A73E8] hover:bg-[#1557B0] text-white font-semibold" data-testid="reset-submit">
              {loading ? t("loading") : t("save")}
            </Button>
          </form>
        )}
        <p className="text-center mt-4 text-sm"><Link to="/login" className="text-[#1A73E8] font-semibold">{t("back")}</Link></p>
      </div>
    </div>
  );
}
